// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import 'react-datepicker/dist/react-datepicker.css';

import React from 'react';
import S from './styles';
interface RadioInputProps extends React.ComponentPropsWithRef<'input'> {
  id?: string; // if duplicated labels are present, you should specify id
  label: string;
  customLabel?: () => JSX.Element;
}

const RadioInput = (props: RadioInputProps): JSX.Element => {
  const { id, className, label, customLabel, ...otherProps } = props;
  return (
    <S.Container className={className} htmlFor={id || label}>
      <S.Radio id={id || label} type="radio" hidden {...otherProps } />
      <S.OuterCircle />
      {customLabel ? customLabel() : <S.Label>{label}</S.Label>}
    </S.Container>
  )
};

export { RadioInput as default };
